<template>
	<div @click="closeModal" class="evModal__closeDates">
		<svg
			width="18"
			height="19"
			viewbox="0 0 18 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<line
				x1="1"
				y1="-1"
				x2="22.4024"
				y2="-1"
				transform="matrix(0.687251 0.72642 -0.687251 0.72642 0 2)"
				stroke="black"
				stroke-width="2"
				stroke-linecap="round"
			/>
			<line
				x1="1"
				y1="-1"
				x2="22.4024"
				y2="-1"
				transform="matrix(0.687251 -0.72642 0.687251 0.72642 1.46094 19)"
				stroke="black"
				stroke-width="2"
				stroke-linecap="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'CloseEventsHeroModal',
	methods: {
		closeModal() {
			const evModal = document.querySelector('.evModal');
			evModal.classList.remove('evModal--open');
		},
	},
};
</script>
